import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../ui/app-dc.icons';

export enum DatablockAction {
	Persist = 'persist',
	Repersist = 'repersist',
	Depersist = 'depersist',
	Delete = 'delete',
}

export interface IDatablockDeleteModalData {
	datablockId: number | Array<number>;
	element: string;
	action: DatablockAction;
}
@Component({
	selector: 'app-datablock-action-popup',
	templateUrl: './datablock-action-popup.component.html',
	styleUrls: ['./datablock-action-popup.component.scss'],
})
export class DatablockActionPopupComponent<
	T extends IDatablockDeleteModalData
> extends DcBaseComponent {
	public readonly Icons = DcIcons;
	public vo$: Observable<{
		element: string;
		datablockId: number | Array<number>;
		isMultipleElement: boolean;
		action: DatablockAction;
	}>;
	public confirmDeletion = false;

	protected readonly DcIcons = DcIcons;
	protected readonly DatablockAction = DatablockAction;
	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'datablock-action';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement:
				Array.isArray(this.modalData.datablockId) &&
				this.modalData.element === '',
			datablockId: this.modalData.datablockId,
			action: this.modalData.action,
		});
	}

	public confirmAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
